import { Block, Color, Text, TextLink, useTelemetry } from '@snowflake/core-ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSignupPageContext } from '../../../pages/SignupContext';
import { FormRow } from '../shared/shared';

export const ThankYouCardBody = () => {
  const { docsLocale } = useSignupPageContext();

  //Set up Telemetry
  const { logAction } = useTelemetry();

  const GettingStartedItem = (props: {
    title: React.ReactNode;
    subtitle: React.ReactNode;
    textLink: React.ReactNode;
  }) => {
    const { title, subtitle, textLink } = props;
    return (
      <FormRow align="left" verticalAlign="top">
        <Block marginRight={8}>
          <img src="/static/images/sf-arrow-icon-blue.svg" />
        </Block>
        <Block>
          <Text color={Color.Gray85} weight="semi-bold" marginBottom={4} allCaps={true}>
            {title}
          </Text>
          <Text marginBottom={4} color={Color.Gray70}>
            {subtitle}
          </Text>
          {textLink}
        </Block>
      </FormRow>
    );
  };

  return (
    <Block marginTop={24}>
      <GettingStartedItem
        title={<FormattedMessage id="Virtual Hands-on Lab" />}
        subtitle={
          <FormattedMessage id="Instructor-led, online lab guiding you through key product features." />
        }
        textLink={
          <TextLink
            color={Color.Blue50}
            href="https://www.snowflake.com/virtual-hands-on-lab/?utm_cta=self-service-trial-thank-you-vhol"
            target="_blank"
            onClick={() => {
              logAction('virtual_lab_link_click', 'ui_click', 'ThankYouCardBody', {});
            }}
          >
            <FormattedMessage id="Reserve Your Seat" />
          </TextLink>
        }
      />
      <GettingStartedItem
        title={<FormattedMessage id="Full Snowflake Documentation" />}
        subtitle={
          <FormattedMessage id="A comprehensive document covering all aspects of Snowflake's Platform." />
        }
        textLink={
          <TextLink
            color={Color.Blue50}
            href={`https://docs.snowflake.com/${docsLocale.value}/`}
            target="_blank"
            onClick={() => {
              logAction('snowflake_docs_link_click', 'ui_click', 'ThankYouCardBody', {});
            }}
          >
            <FormattedMessage id="Go To Documentation" />
          </TextLink>
        }
      />
    </Block>
  );
};
